export enum EntityType {
    Client,
    Representant,
    Beneficiary
  }
  
  export const entityTypeValues: { [id: number]: string } = {
    0: 'Cliente o Usuario',
    1: 'Representante Legal',
    2: 'Beneficiario Controlador'
  };
  
  export namespace EntityType {
    export function values() {
      return Object.keys(EntityType)
        .filter(type => isNaN(<any>type) && type !== 'values')
        .map((key, index) => {
          return { key: entityTypeValues[index], value: index };
        });
    }
  }
  